export const getEnv = (key, defaultValue = "") => {
	const viteValue = import.meta.env[`VITE_${key}`];
	if (viteValue !== undefined) {
		return viteValue;
	}

	const reactValue = import.meta.env[`REACT_APP_${key}`];
	if (reactValue !== undefined) {
		return reactValue;
	}

	return defaultValue;
};

export const processEnv = {
	REACT_APP_API_URL: getEnv("API_URL"),
	REACT_APP_VERSION: getEnv("VERSION"),
	REACT_APP_SENTRY_DSN: getEnv("SENTRY_DSN") || getEnv("SENTRY_DNS"),
	REACT_APP_SENTRY_DNS: getEnv("SENTRY_DNS"),
	REACT_APP_SENTRY_ENV: getEnv("SENTRY_ENV"),
	REACT_APP_API_GO: getEnv("API_GO"),
};

export default {
	API_URL: getEnv("API_URL"),
	VERSION: getEnv("VERSION") || getEnv("APP_VERSION"),
	SENTRY_DSN: getEnv("SENTRY_DSN") || getEnv("SENTRY_DNS"),
	SENTRY_DNS: getEnv("SENTRY_DNS"),
	SENTRY_ENV: getEnv("SENTRY_ENV"),
	API_GO: getEnv("API_GO"),
	MODE: import.meta.env.MODE,
	DEV: import.meta.env.DEV,
	PROD: import.meta.env.PROD,
};
